import { NgModule } from '@angular/core';

import { IconModule } from '../icon/icon.module';
import { BaseButtonDirective } from './base-button';
import { ButtonNewComponent } from './components/button/button.comonent';
import { IconButtonComponent } from './components/icon-button/icon-button.component';
import { PlanButtonComponent } from './components/plan-button/plan-button.component';
import { ButtonDropdownIndicatorDirective } from './directives/button-dropdown/button-dropdown-indicator.directive';
import { ButtonLoadingDirective } from './directives/button-loading/button-loading.directive';

@NgModule({
  imports: [IconModule],
  declarations: [
    ButtonNewComponent,
    ButtonDropdownIndicatorDirective,
    ButtonLoadingDirective,
    IconButtonComponent,
    BaseButtonDirective,
    PlanButtonComponent,
  ],
  exports: [
    ButtonNewComponent,
    ButtonDropdownIndicatorDirective,
    ButtonLoadingDirective,
    IconButtonComponent,
    PlanButtonComponent,
  ],
})
export class ButtonNewModule {}
export {
  ButtonNewComponent,
  ButtonDropdownIndicatorDirective,
  ButtonLoadingDirective,
  IconButtonComponent,
  BaseButtonDirective,
  PlanButtonComponent,
};
